export function parsePiHeaderSlotItem(item, { isOmitted }) {
  if (isOmitted(item)) {
    return null;
  }
  if (item.children) {
    item.children = item.children.map((x) => parsePiHeaderSlotItem(x, { isOmitted })).filter((x) => x);
  }
  return item;
}
